// extracted by mini-css-extract-plugin
module.exports = {"table":"bannerTable_table__yE6dy","tableRow":"bannerTable_tableRow__Zh3Ql"};